// ActionButtons.js
import { IconButton } from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';

const ActionButtons = ({ notificationData, onPreview, onRevoke }) => {
  return (
    <>
      <IconButton onClick={() => onPreview(notificationData)} color="primary">
        <PreviewIcon />
      </IconButton>
      <IconButton onClick={() => onRevoke(notificationData)} color="secondary">
        <DoDisturbIcon />
      </IconButton>
    </>
  );
};

export default ActionButtons;
